import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Tab, Tabs } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import arrow from "../assets/images/arrow.png";
import arrowLeft from "../assets/images/arrow-left.png";
import age from "../assets/images/age.webp";
import ProgramTimeline from './ProgramTimeline';
import { getPrograms } from '../services/ProgramApi';
import LoadingSpinner from './LoadingSpinner';
import config from '../config/config';

const Programs = () => {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const activeTab = location.state?.activeTab || "all";

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const response = await getPrograms();
        if (response.data.data && Array.isArray(response.data.data)) {
          setPrograms(response.data.data);
        } else {
          throw new Error("Unexpected API response format");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to fetch programs");
      } finally {
        setLoading(false);
      }
    };
    fetchPrograms();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='app-container mobile-bottom'>
      <Container>
        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
            <Link to='/dashboard'><img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            All Programs</h2>
        </div>
        <div>
          <Tabs
            defaultActiveKey={activeTab}
            transition={true}
            id="ProgramsTabs"
            className="mb-3 custom-tabs"
            fill
          >
            <Tab eventKey="my" title="My Programs">
              <ProgramTimeline />
            </Tab>
            <Tab eventKey="all" title="All Programs">
              <h3 className='my-3 d-flex align-items-center fs-18'>
                <img src={age} width={40} className='me-2' alt="link" />
                Ages 6 to 16 years</h3>
              <Row className='mb-3'>
                {programs.map((program, index) => (
                  <Col xs='12' key={program.id || index}>
                    <Card className='mb-3'>
                      <Link to={`/course/${program.id}`} className='text-decoration-none text-dark'>
                        <Card.Body className='d-flex align-items-center'>
                          <div className='program_img me-2'>
                            <img src={`${config.Image_Base_URL}${program.program_image}`} alt='program' width={100} height={80} className="rounded-3" />
                          </div>
                          <div className='program_content w-100'>
                            <Card.Title className='mb-1 fs-16'>
                              {program.program_name}
                            </Card.Title>
                            <Card.Text className='mb-1 fs-10'>{program.program_desc}</Card.Text>
                            <Card.Subtitle className='program-subtitle fs-8 mt-1'>Age Group: {program.age_group} Years</Card.Subtitle>
                          </div>
                          <div className=''>
                            <img src={arrow} width={12} alt="link" />
                          </div>
                        </Card.Body>
                      </Link>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Tab>
          </Tabs>
        </div>
      </Container>
    </div>
  );
}

export default Programs;